export enum MatterWorkTypeEnum {
  Coding = 0,
  Auditing = 1
}

export enum MatterWorkTypeNameEnum {
  Coding = 'Coding',
  Auditing = 'Auditing'
}

export enum MatterWorkSearchTypeEnum {
  Name = 'Name',
  Description = 'Description'
}
